module.exports = __webpack_public_path__ + "static/media/tick-circle-blue.33a7320b.svg";